"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/esnext.map.delete-all.js";
import "core-js/modules/esnext.map.every.js";
import "core-js/modules/esnext.map.filter.js";
import "core-js/modules/esnext.map.find.js";
import "core-js/modules/esnext.map.find-key.js";
import "core-js/modules/esnext.map.includes.js";
import "core-js/modules/esnext.map.key-of.js";
import "core-js/modules/esnext.map.map-keys.js";
import "core-js/modules/esnext.map.map-values.js";
import "core-js/modules/esnext.map.merge.js";
import "core-js/modules/esnext.map.reduce.js";
import "core-js/modules/esnext.map.some.js";
import "core-js/modules/esnext.map.update.js";
import "core-js/modules/web.dom-collections.iterator.js";
let MissingKeysHandler = /*#__PURE__*/function () {
  function MissingKeysHandler(options = {}) {
    var _options$batchSize, _options$debounceMs, _options$enableConsol;
    _defineProperty(this, "missingKeys", new Map());
    _defineProperty(this, "batchTimer", null);
    this.options = {
      batchSize: (_options$batchSize = options.batchSize) !== null && _options$batchSize !== void 0 ? _options$batchSize : 50,
      debounceMs: (_options$debounceMs = options.debounceMs) !== null && _options$debounceMs !== void 0 ? _options$debounceMs : 5000,
      enableConsoleLogging: (_options$enableConsol = options.enableConsoleLogging) !== null && _options$enableConsol !== void 0 ? _options$enableConsol : true
    };
  }

  /**
   * Add a missing key to the collection
   */
  var _proto = MissingKeysHandler.prototype;
  _proto.addMissingKey = function addMissingKey(data) {
    var _data$timestamp;
    const keyId = `${data.ns}:${data.key}`;

    // Add timestamp if not present
    const enrichedData = _objectSpread(_objectSpread({}, data), {}, {
      timestamp: (_data$timestamp = data.timestamp) !== null && _data$timestamp !== void 0 ? _data$timestamp : Date.now()
    });
    this.missingKeys.set(keyId, enrichedData);

    // Schedule batch save
    this.scheduleBatchSave();
  }

  /**
   * Schedule a batch save of missing keys
   */;
  _proto.scheduleBatchSave = function scheduleBatchSave() {
    // Clear existing timer
    if (this.batchTimer) {
      clearTimeout(this.batchTimer);
    }

    // Set new timer
    this.batchTimer = setTimeout(() => {
      this.saveMissingKeys();
    }, this.options.debounceMs);
  }

  /**
   * Save missing keys (placeholder implementation)
   */;
  _proto.saveMissingKeys = async function saveMissingKeys() {
    if (this.missingKeys.size === 0) {
      return;
    }

    // Get keys to save
    const keysToSave = Array.from(this.missingKeys.values());

    // Clear the collection
    this.missingKeys.clear();

    // Placeholder: Log to console (only in development)
    if (__DEBUG__ && this.options.enableConsoleLogging) {
      console.warn('[i18n-missing-keys-handler] Missing translation keys detected:', {
        count: keysToSave.length,
        keys: keysToSave.map(k => ({
          namespace: k.ns,
          key: k.key,
          languages: k.lng
        }))
      });
    }

    // TODO: Replace with actual backend endpoint call
    // await fetch('/api/i18n/missing-keys', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify({ keys: keysToSave }),
    // });
  }

  /**
   * Force save all pending missing keys immediately
   */;
  _proto.flush = async function flush() {
    if (this.batchTimer) {
      clearTimeout(this.batchTimer);
      this.batchTimer = null;
    }
    await this.saveMissingKeys();
  }

  /**
   * Get current count of pending missing keys
   */;
  _proto.getPendingCount = function getPendingCount() {
    return this.missingKeys.size;
  };
  return MissingKeysHandler;
}(); // Create singleton instance
const handler = new MissingKeysHandler();

/**
 * Save missing translation keys
 * This is the main export that will be used by i18next
 */
export const saveMissingKeys = async (lng, ns, key, fallbackValue) => {
  handler.addMissingKey({
    lng,
    ns,
    key,
    fallbackValue
  });
};

/**
 * Force flush all pending missing keys
 */
export const flushMissingKeys = async () => {
  await handler.flush();
};

/**
 * Get count of pending missing keys
 */
export const getPendingMissingKeysCount = () => {
  return handler.getPendingCount();
};

// Export type for configuration